import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  loadSetting () {
    const api = getApiClient(this.$store)
    const settingId = this.$route.params.id

    api.get(`settings/${settingId}`)
      .then(result => {
        this.setting = result.data
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const options = {
      headers: {
        'Content-Type': 'application/merge-patch+json',
      },
    }

    if (this.setting.dataType === 'image' && !this.setting.value.match(/base64,/g)) {
      delete this.setting.value
    }
    api.patch(this.setting['@id'], this.setting, options)
      .then(() => {
        this.$store.commit('app/raiseSuccess', 'Configuração salva com sucesso')
        this.$router.push({
          name: 'Settings',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar configuração')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
